import { ReactNode } from 'react';
/////////////////////////////////////////////////////////////
interface PageTitleProps {
	children: ReactNode;
}

export const PageTitle: React.FC<PageTitleProps> = ({
	children,
}: PageTitleProps) => {
	/*********************
	// #region Template
	**********************/
	return (
		<h1 className="flex items-center font-bold text-2xl text-center mb-2 leading-tight">
			{children}
		</h1>
	);
};
